import { useRespondToRange } from "@animech/ui";
import { FunctionComponent } from "react";
import * as Styled from "./loading-panel.style";
import { Logo, LogoSources } from "src/ui";

export type LoadingPanelProps = {
	logoSources?: LogoSources;
	variant?: "solid" | "backdrop";
};

export const LoadingPanel: FunctionComponent<LoadingPanelProps> = ({
	logoSources,
	variant = "solid",
}: LoadingPanelProps) => {
	const isTabletDown = useRespondToRange("tablet", "down");

	return (
		<Styled.Root data-testid="loading-panel" data-variant={variant}>
			{logoSources?.desktop && !isTabletDown && (
				<Logo src={logoSources?.desktop} />
			)}
			{logoSources?.mobile && isTabletDown && (
				<Logo src={logoSources?.mobile} />
			)}
			<Styled.ProgressWrapper>
				<Styled.Progress color="tertiary" type="circular" size={140} />
			</Styled.ProgressWrapper>
		</Styled.Root>
	);
};
